// js
import React from 'react';
import { connect } from 'react-redux';
import dsaView, { defaultPropTypes } from '../dsaView';
import AnalyticsControls from '../../components/analytics/AnalyticsControls';
// css
import '../../styles/containers/analytics/analyticsView.scss';


export default function analyticsView(WrappedComponent) {

  const mapStateToProps = () => {
    return {};
  };

  const mapDispatchToProps = () => {
    return {};
  };

  return dsaView(connect(mapStateToProps, mapDispatchToProps)(props => (
    <div className='analytics'>
      <div className='analytics__content'>
        <div className='container'>
          <WrappedComponent {...props} />
        </div>
      </div>
      <AnalyticsControls
        abilities={props.abilities}
        currentAreaId={props.params.areaId}
        currentDashboardCategoryId={props.params.dashboardCategoryId}
        navigableAreas={props.activeAreas}
        navigableDashboardCategories={props.navigableDashboardCategories}
        extensions={props.extensions}
        location={props.location}
        currentPage={props.analyticsPage}
      />
    </div>
  )), { className: 'analytics-view' });
}

export { defaultPropTypes };



// WEBPACK FOOTER //
// ./src/containers/analytics/analyticsView.js